/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { IpUserInterfaceService } from '../../services/internals/user-interfaces/user-interface.service';
import { IpEmailObjectStoreService } from '../../services/internals/ip-email-object-store/ip-email-object-store.service';

@Component({
  selector: 'ip-structure-settings',
  templateUrl: './structure-settings.component.html',
  styleUrls: ['./structure-settings.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class StructureSettingsComponent {
  currentStructure$ = this.ipInternalService.currentEditingStructure$;

  constructor(private ipInternalService: IpUserInterfaceService, private emailObject: IpEmailObjectStoreService) {}

  markForCheck() {
    this.emailObject.markForCheck();
  }
}
